export default "__VITE_ASSET__Ci_1Vb8l__"